import { render, staticRenderFns } from "./PWStudio.vue?vue&type=template&id=05ef6cec&scoped=true&"
import script from "./PWStudio.vue?vue&type=script&lang=js&"
export * from "./PWStudio.vue?vue&type=script&lang=js&"
import style0 from "./PWStudio.vue?vue&type=style&index=0&id=05ef6cec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ef6cec",
  null
  
)

component.options.__file = "PWStudio.vue"
export default component.exports